import React, { ComponentType } from 'react'
import { View } from 'src/ui/basic/View'
import { css } from 'src/ui/style/css'
import { useTran } from 'src/i18n/useTran'
import { msg } from 'src/i18n/texts/keys'
import { Text } from 'src/ui/basic/Text'
import {
    centeredContent,
    grid,
    paddedContent,
    verticalChildSpacing
} from 'src/ui/style/mixins/layout'
import { Divider } from 'src/ui/Divider'
import { useTheme } from 'src/ui/style/useTheme'
import { ContactColumn } from 'src/layout/footer/ContactColumn'
import { AppCardColumn } from 'src/layout/footer/AppCardColumn'
import { PagesColumn } from 'src/layout/footer/PagesColumn'
import { InfoColumn } from 'src/layout/footer/InfoColumn'
import { mediaMaxWidth } from 'src/ui/style/mixins/helpers'
import { Version } from 'src/version/VersionInfo'
import { useSearchParams } from '../../app/useSearchParams'
import { isAndroidNativeApp, isIosNativeApp } from 'src/geo/locationService'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export const Footer: ComponentType = () => {
    const t = useTran()
    const th = useTheme()
    const actualYear = new Date().getFullYear()
    const limitedView = useSearchParams().get('limitedView') === 'true'

    const isNativeApp =
        (isIosNativeApp() || isAndroidNativeApp()) &&
        location.pathname === routes.landingWebview.path

    if (limitedView || isNativeApp) return null

    return (
        <>
            <footer
                css={css`
                    // Displays footer columns and copyright text in column direction
                    // and overrides default link color behaviour
                    display: flex;
                    flex-direction: column;
                    background: ${th.colors.tertiary};
                    color: ${th.colors.white};
                    a {
                        color: ${th.colors.white};
                    }
                `}
            >
                <View
                    horizontal
                    css={[
                        centeredContent()(th),
                        paddedContent()(th),
                        css`
                            // Spread footer columns and dividers to sides
                            justify-content: space-between;
                            align-items: stretch;
                            // Sets footer columns to grid (dividers are hidden)
                            ${mediaMaxWidth(th.screens.md)} {
                                ${grid({
                                    minWidth: '14em',
                                    gap: `${th.spacing.lg} ${th.spacing.md}`
                                })}
                            }
                            column-gap: ${th.spacing.md};
                        `
                    ]}
                >
                    <ContactColumn />
                    <div css={css`${mediaMaxWidth(th.screens.md)} { display: none; }`}><Divider vertical /></div>
                    <PagesColumn />
                    <div css={css`${mediaMaxWidth(th.screens.md)} { display: none; }`}><Divider vertical /></div>
                    <InfoColumn />
                    <div css={css`${mediaMaxWidth(th.screens.md)} { display: none; }`}><Divider vertical /></div>
                    <AppCardColumn />
                    <div css={css`${mediaMaxWidth(th.screens.md)} { display: none; }`}><Divider vertical /></div>
                </View>
                <Divider />
                <View
                    horizontal
                    css={[
                        centeredContent()(th),
                        css`
                            // Sets aligment of copyright text
                            padding: ${th.spacing.md} ${th.spacing.lg};
                            justify-content: flex-start;
                            // Centers copyright text and reduce padding
                            ${mediaMaxWidth(th.screens.md)} {
                                padding: ${th.spacing.md};
                                text-align: center;
                            }
                        `
                    ]}
                >
                    <View
                        horizontal
                        css={css`
                            width: 100%;
                            justify-content: space-between;
                            ${mediaMaxWidth(th.screens.sm)} {
                                flex-direction: column;
                                ${verticalChildSpacing(th.spacing.sm)(th)};
                            }
                        `}
                    >
                        <Text>
                            {t(msg.ui.footer.copyright, { year: actualYear })}
                        </Text>
                        <Version />
                    </View>
                </View>
            </footer>
        </>
    )
}
